module.exports = __webpack_public_path__ + "static/media/view2.3f58392e.jpg";